import { Response, Country, apiAbortController } from '@ui/src';
import api from '../../../api/api';

export const geographicalRiskApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAmlCountries: build.query<Response<Country>, string>({
      query: (query) => ({
        url: `/v1/countries${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateGeographicalRiskScore: build.mutation<
      {
        data: Country;
      },
      {
        id: string;
        body: {
          riskScore: number;
        };
      }
    >({
      query: (data) => ({
        url: `/v1/countries/${data.id}/risk-score`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getGeographialRisk: build.query<{ data: Country }, string>({
      query: (id) => ({
        url: `/v1/countries/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetAmlCountriesQuery,
  useLazyGetGeographialRiskQuery,
  useUpdateGeographicalRiskScoreMutation,
} = geographicalRiskApi;

export const {
  endpoints: {
    getAmlCountries,
    getGeographialRisk,
    updateGeographicalRiskScore,
  },
} = geographicalRiskApi;
